<template>
    <div class="clear bcw buybar">
      <!-- <div class="buybar__content clear">
        <div class="left clear buybar__price">
            <div class="c3 left">¥{{ price }}</div>
        </div>
        <div v-if="queue == 1 || queue==-1" class="left clear buybar__queue mln mtn">
            <div class="c3 fs2">已满员 {{queueNum}}人排队中</div>
            <div class="c9 fs2">满足条件后，开设小班</div>
        </div>
        <div v-show="buybtn" class="buybar__btnbox">
          <van-button v-if="isBuy === true" v-cloak type="default" size="normal" class="buybar__btn right fs3" disabled>您已购买</van-button>
          <div v-else v-cloak>
            <van-button v-if="queue == 0 && ordertype==false" type="primary" @click="ceateOrder" size="normal" class="buybar__btn right fs3">立即购买</van-button>
            <van-button v-if="queue == 0 && ordertype==true" type="primary" @click="showOrder=true" size="normal" class="buybar__btn right fs3">立即购买</van-button>
            <van-button v-if="queue == 1" type="primary" size="normal" @click="pushQueue" class="right fs3">排队</van-button>
            <van-button v-if="queue == -1" type="primary" size="normal" class="right fs3" disabled>已排队</van-button>
          </div>
        </div>
      </div>

      <c-order
        v-model="showOrder"
        :targetId="id"
        :targetType="type"
        :price="price"
        :payment="payment"
        :orderTitle="orderTitle">
      </c-order> -->
    </div>
</template>
<script>
import Vue from "vue";
import { Toast } from 'vant';
import Func from "@/assets/scripts/func";
import query from 'query-string';
import COrder from '@/components/order';
Vue.use(Toast)
export default {
    name: 'TheBuybar',
    components: {
      COrder
    },
    props: {
      price: {
        // type: Number,
        default:'',
        required: true
      },
      oprice: {
        // type: Number,
        default:0,
        required: true,
      },
      id: {
        type: Number,
        default:0,
        required: true
      },
      type: {
        type: String,
        default: 'clubPracticeCard',  //默认练球卡
        required: true
      },
      payment: {
        type: String,
        default: 'wxpay'
      },
      queue: {   //排队状态
        type: Number,
        default: 0
      },
      queueNum:{  //排队人数
        type:Number,
        default:0
      },
      isBuy:{
        default: null
      },
      ordertype:{  //是否有弹出层
        type:Boolean,
        default:false
      },
      orderTitle:{  //课程名称
        type:String
      }
    },
    data(){
      return {
        order: {},
        buybtn:false,
        showOrder:false,//弹出层
      }
    },
    beforeUpdate() {
      this.buybtn=true
    },
    methods: {
      ceateOrder: function(){
        if (!Func.isSetCookie('_ibl')) {
          // this.$router.push({ name: 'login', query: { redirect: location.href }})
          location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
          return
        }
        this.$http.post('order/create',{
          targetId: this.id,
          targetType: this.type,
          payment: this.payment,
        }).then(res => {
          this.order = res.data.value
          if(!res.data.code){
            let domain = location.origin
            location.href = `${domain}/m/pay_page?orderId=${this.order.id}&sn=${this.order.sn}&redirect=${encodeURIComponent(domain + '/venue/#/orderview/' + this.order.id +'/'+ this.type)}`;
          }else{
            Toast.fail(res.data.message)
          }
        })
      },
      pushQueue(){
        if (!Func.isSetCookie('_ibl')) {
          location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
          return
        }
        this.$http.get('club_group_course/queue?courseId=' + this.id).then(res => {
          if(!res.data.code){
            this.queue = -1;
            Toast('排队成功')
          }else{
            Toast.fail(res.data.message)
          }
        })
      }
    },
}
</script>
<style lang="less" scoped>
[v-cloak] {
  display: none!important;
}
.buybar{    
    // height: .65rem;
    // border-top: 1px solid #f6f6f6;
    &__price{
        line-height: .45rem;
        font-size: .2rem;
        &>del{
            margin-left: .1rem;
        }
    }
    &__queue{
      margin-left: .1rem;
    }
    &__btn{
        width: 40%;
        height: .44rem;
    }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheBuybar.vue